/*
 * gastro-product-specs.js
 *
 * The imported product descriptions are flat runs of "Label: Value"
 * paragraphs ("Spanning: 230 V", "Koelmiddel: R600a", …). Rendered as
 * body copy that's a wall of one-line paragraphs; as a definition list
 * it reads as the spec sheet it actually is.
 *
 * Progressive enhancement only: anything that isn't a run of at least
 * MIN_ROWS label/value lines is left exactly as it was, and a
 * description that already contains a table or list is skipped.
 */
(function () {
  var MIN_ROWS = 3;
  // "Label: Value" — label is short, has no sentence punctuation, and the
  // value is non-empty. Keeps prose like "Achtung: ..." paragraphs out.
  var PAIR = /^\s*([^:.!?]{2,48}?)\s*:\s*(\S.*)$/;

  function parse(text) {
    var m = PAIR.exec(text);
    if (!m) return null;
    // a label with more than ~5 words is a sentence, not a spec name
    if (m[1].split(/\s+/).length > 5) return null;
    return { label: m[1].trim(), value: m[2].trim() };
  }

  function buildList(pairs, doc) {
    var dl = doc.createElement('dl');
    dl.className = 'gastro-specs';
    pairs.forEach(function (pair) {
      var row = doc.createElement('div');
      row.className = 'gastro-specs__row';
      var dt = doc.createElement('dt');
      dt.textContent = pair.label;
      var dd = doc.createElement('dd');
      dd.textContent = pair.value;
      row.appendChild(dt);
      row.appendChild(dd);
      dl.appendChild(row);
    });
    return dl;
  }

  /* One paragraph holding <br>-separated lines is the other shape these
     imports come in. Split it first so the run-detection below sees rows. */
  function splitLineBreaks(root, doc) {
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (!p.querySelector('br')) return;
      var lines = p.innerHTML.split(/<br\s*\/?>/i);
      if (lines.length < MIN_ROWS) return;
      var frag = doc.createDocumentFragment();
      var made = 0;
      lines.forEach(function (line) {
        var el = doc.createElement('p');
        el.innerHTML = line;
        if (!el.textContent.trim()) return;
        frag.appendChild(el);
        made++;
      });
      if (made >= MIN_ROWS) p.parentNode.replaceChild(frag, p);
    });
  }

  function enhance(root) {
    var doc = root.ownerDocument;
    if (root.dataset.gastroSpecs === 'done') return;
    if (root.querySelector('table, dl, ul, ol')) return;

    splitLineBreaks(root, doc);

    var children = Array.prototype.slice.call(root.children);
    var run = [];

    function flush() {
      if (run.length >= MIN_ROWS) {
        var pairs = run.map(function (entry) {
          return entry.pair;
        });
        var first = run[0].node;
        first.parentNode.insertBefore(buildList(pairs, doc), first);
        run.forEach(function (entry) {
          entry.node.parentNode.removeChild(entry.node);
        });
      }
      run = [];
    }

    children.forEach(function (node) {
      var pair = node.tagName === 'P' ? parse(node.textContent) : null;
      if (pair && !node.querySelector('img, iframe, a')) {
        run.push({ node: node, pair: pair });
      } else {
        flush();
      }
    });
    flush();

    root.dataset.gastroSpecs = 'done';
  }

  function run() {
    document.querySelectorAll('.product__description').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Dawn swaps the info column's markup when a variant changes. */
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('variant:change', run);
})();
